import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { show } from '@intercom/messenger-js-sdk';
import Transition from '../utils/Transition';
import { useThemeProvider } from '../utils/ThemeContext';

function DropdownHelp({
  align
}) {

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { isDirect, isApp } = useThemeProvider();
  const { user, isAuthenticated } = useSelector((state) => state.app);
  const intercomChatAvailable =
    isAuthenticated && Boolean(user?.id) && isDirect && !isApp;

  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="relative inline-flex">
      <button
        ref={trigger}
        className={`w-8 h-8 flex items-center justify-center bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600/80 rounded-full ${
          dropdownOpen && "bg-slate-200"
        }`}
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Need help?</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="stroke-current text-slate-500 dark:text-slate-40"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="1.75"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
          <path d="M21 21l-6 -6" />
          <path d="M10 13l0 .01" />
          <path d="M10 10a1.5 1.5 0 1 0 -1.14 -2.474" />
        </svg>
        {/*<svg*/}
        {/*  className="w-4 h-4"*/}
        {/*  viewBox="0 0 16 16"*/}
        {/*  xmlns="http://www.w3.org/2000/svg"*/}
        {/*>*/}
        {/*  <path*/}
        {/*    className="fill-current text-slate-500 dark:text-slate-400"*/}
        {/*    d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"*/}
        {/*  />*/}
        {/*</svg>*/}
      </button>

      <Transition
        className={`origin-top-right z-10 absolute top-full min-w-44 bg-white dark:bg-theme-surface-accent border border-slate-200 dark:border-slate-700 py-1.5 rounded shadow-lg overflow-hidden mt-1 ${
          align === "right" ? "right-0" : "left-0"
        }`}
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
        >
          <div className="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase pt-1.5 pb-2 px-3">
            Need help?
          </div>
          <ul>
            {/*<li>*/}
            {/*  <Link*/}
            {/*    className="font-medium text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center py-1 px-3"*/}
            {/*    to="#0"*/}
            {/*    onClick={() => setDropdownOpen(!dropdownOpen)}*/}
            {/*  >*/}
            {/*    <svg className="w-3 h-3 fill-current text-indigo-300 dark:text-indigo-500 shrink-0 mr-2" viewBox="0 0 12 12">*/}
            {/*      <rect y="3" width="12" height="9" rx="1" />*/}
            {/*      <path d="M2 0h8v2H2z" />*/}
            {/*    </svg>*/}
            {/*    <span>Documentation</span>*/}
            {/*  </Link>*/}
            {/*</li>*/}
            <li>
              <Link
                className="font-medium text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center py-1 px-3"
                to="https://intercom.help/sauceydirect/en/"
                target="_blank"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <svg
                  className="w-3 h-3 fill-current text-indigo-300 dark:text-indigo-500 shrink-0 mr-2"
                  viewBox="0 0 12 12"
                >
                  <path d="M10.5 0h-9A1.5 1.5 0 000 1.5v9A1.5 1.5 0 001.5 12h9a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0010.5 0zM10 7L8.207 5.207l-3 3-1.414-1.414 3-3L5 2h5v5z" />
                </svg>
                <span>Support Site</span>
              </Link>
            </li>
            <li>
              {intercomChatAvailable ? (
                <button
                  type="button"
                  className="font-medium text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center py-1 px-3 w-full text-left"
                  onClick={() => {
                    show();
                    setDropdownOpen(false);
                  }}
                >
                  <svg
                    className="w-3 h-3 fill-current text-indigo-300 dark:text-indigo-500 shrink-0 mr-2"
                    viewBox="0 0 12 12"
                  >
                    <path d="M11.854.146a.5.5 0 00-.525-.116l-11 4a.5.5 0 00-.015.934l4.8 1.921 1.921 4.8A.5.5 0 007.5 12h.008a.5.5 0 00.462-.329l4-11a.5.5 0 00-.116-.525z" />
                  </svg>
                  <span>Chat with us</span>
                </button>
              ) : (
                <Link
                  className="font-medium text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 flex items-center py-1 px-3"
                  to="mailto:merchant-support@sauceydirect.com"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <svg
                    className="w-3 h-3 fill-current text-indigo-300 dark:text-indigo-500 shrink-0 mr-2"
                    viewBox="0 0 12 12"
                  >
                    <path d="M11.854.146a.5.5 0 00-.525-.116l-11 4a.5.5 0 00-.015.934l4.8 1.921 1.921 4.8A.5.5 0 007.5 12h.008a.5.5 0 00.462-.329l4-11a.5.5 0 00-.116-.525z" />
                  </svg>
                  <span>Contact us</span>
                </Link>
              )}
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default DropdownHelp;